import { render, staticRenderFns } from "./depreCiationInformation.vue?vue&type=template&id=40803c32&scoped=true&"
import script from "./depreCiationInformation.vue?vue&type=script&lang=js&"
export * from "./depreCiationInformation.vue?vue&type=script&lang=js&"
import style0 from "./depreCiationInformation.vue?vue&type=style&index=0&id=40803c32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40803c32",
  null
  
)

export default component.exports